export default class UploadFileError extends Error {
  constructor() {
    super('upload error');
    this.name = 'UploadFileError';
  }
}
